import Resource from '@assets/utils/resource';
import {
    onAddPaymentInfo,
    onAddShippingInfo,
    onAddToWishlist,
    onCheckoutBegin,
    onSearch,
    onViewCart,
    onViewItemList,
} from '@gtmcustom/gtm/gtmEvents';

const enabled = Resource.getSitePreference('google', 'googleTagManagerEnabled');
const noShoppable = Resource.getSitePreference('storefront', 'isNonShoppable');

export async function getSubTotal() {
    if (!enabled || noShoppable) return 0;
    const subTotalUrl = window.getCartTotalAction;
    const data = await $.ajax({
        url: subTotalUrl,
        method: 'GET',
        dataType: 'json',
        error(error) {
            console.error(error);
        },
    });
    const dataCondition = data ? !!data.cartSubTotal : false;
    return dataCondition ? data.cartSubTotal : 0;
}

export function listViewGTM(listID) {
    if (!enabled) return;
    const products = window.productListObj[0];
    onViewItemList(listID, products);
}

export function itemSelect(listID) {
    if (!listID || !enabled) return;
    $(document).on('click', '.product-tile a', async (e) => {
        if (!window.productListObj || !window.productListObj[0] || !window.productListObj[0].length) return;
        const productID = $(e.currentTarget).closest('.product').data('pid');
        const product = window.productListObj[0].find((item) => item.item_id === productID || item.item_variant === productID);
        if (!product) return;
        const itemSelectObj = [{
            item_list_id: listID,
            product,
        }];
        sessionStorage.setItem('item_select', JSON.stringify(itemSelectObj));
    });
}

export async function getQuantityInCart(pid) {
    if (!enabled) return 0;
    const quantityUrl = `${window.getItemQuantityInCart}?pid=${pid}`;
    const data = await $.ajax({
        url: quantityUrl,
        method: 'GET',
        dataType: 'json',
        error(error) {
            console.error(error);
        },
    });
    const dataCondition = data ? !!data.quantity : false;
    const quantity = dataCondition ? data.quantity : 0;
    return quantity;
}

export async function getProductFromCart(pid) {
    if (!enabled) return {};
    const products = window.productCartObj;
    if (!products) {
        const getProductUrl = `${window.getProductFromCart}?pid=${pid}`;
        const data = await $.ajax({
            url: getProductUrl,
            method: 'GET',
            dataType: 'json',
            error(error) {
                console.error(error);
            },
        });
        return data.productLineItem;
    }
    return products.find((product) => product.item_id === pid);
}

export async function gtmCartView() {
    if (!enabled) return;
    const products = window.productCartObj;
    if (!products) return;
    const subTotal = await getSubTotal();
    onViewCart(products, subTotal);
}

export function getGtmCheckoutObject() {
    if (!enabled) return;
    const products = window.productCheckoutObj;
    if (!products) return;
    const subTotal = window.totalValue;
    onCheckoutBegin(products, subTotal);
}

export function getSubmitShippingGtm(shippingMethod) {
    if (!enabled) return;
    const products = window.productCheckoutObj;
    if (!products) return;
    const subTotal = window.totalValue;
    onAddShippingInfo(products, subTotal, shippingMethod);
}

export function getSubmitPaymentGtm(paymentMethod) {
    if (!enabled) return;
    const products = window.productCheckoutObj;
    if (!products || !enabled) return;
    const subTotal = window.totalValue;
    onAddPaymentInfo(products, subTotal, paymentMethod);
    sessionStorage.setItem('paymentMethodShown', true);
}

export function getPurchaseGtm() {
    const products = window.productCheckoutObj;
    if (!products || !enabled) return;
    const dataObject = {
        products,
        subTotal: window.totalValue,
    };
    sessionStorage.setItem('purchase', JSON.stringify(dataObject));
}

export function getAddToWishlistGtm(data) {
    if (!enabled) return;
    if (data?.action !== 'Wishlist-AddProduct') return;
    const product = window.pdpProduct || window.productListObj?.[0]?.find(
        (item) => item.item_id === data.pid || item.item_variant === data.pid,
    );
    if (!product) return;
    onAddToWishlist(product);
}

export function tileGtm() {
    if (!enabled) return;
    const $gtmTile = $('.gtm-tile');
    if ($gtmTile.length) {
        const listID = $gtmTile.data('list-id');
        window.productListObj = [[]];
        $gtmTile.each((index, tile) => {
            const gtmData = $(tile).data('product-gtm');
            gtmData.index = index;
            window.productListObj[0].push(gtmData);
        });
        listViewGTM(listID);
        itemSelect(listID);
    }
}

export function SearchGtm() {
    if (!enabled) return;
    const currentUrl = new URL(window.location.href);
    if (currentUrl.pathname.split('/').pop() === 'search') {
        const searchParam = currentUrl.searchParams.get('q');
        onSearch(searchParam);
    }
}
